import { FaArrowsRotate, FaBrain, FaGamepad } from "react-icons/fa6";


export const proProgramsData = [
    {
        id: 1,
        title: "Non-Invasive Brain Exercise",
        description:
            "Our technique gently trains the brain, promoting healthier activity. It's a series of sessions that motivate brains without drug use. This improvement in focus, mood, and thinking is noticeable.",
    },
    {
        id: 2,
        title: "Long-Term Benefits",
        description:
            "Neurofeedback teaches patients self-regulation techniques. These improve brain function, enhance cognitive health, and help with memory issues.",
    },
];

export const featuresCardData = [
    {
        icon: <FaBrain />,
        title: "Brain Scanning",
        description:
            "We begin by scanning the brain. Our instruments map brainwave activity without causing harm or discomfort, helping us see which parts of the brain need help.",
    },
    {
        icon: <FaGamepad />,
        title: "Customized Training Sessions",
        description:
            "In these sessions, participant’s brainwaves control interactive activities. Positive encouragement can help the brain develop better habits, which can, over time, improve memory, concentration, and mood.",
    },
    {
        icon: <FaArrowsRotate />,
        title: "Consistent Checking",
        description:
            "We track progress closely, using more brain scans and session information. If necessary, we adjust the program to keep progress going.",
    },
];